import { MutationTree } from "vuex";
import { DatasetStateInterface } from "./state";
import {
  ClassItem,
  ClassGroupItem,
  MarkupType,
  ObjectItem,
  ObjectType,
  Source,
  Storage,
  Tag,
} from "../../models";

const mutation: MutationTree<DatasetStateInterface> = {
  init(state: DatasetStateInterface, payload: boolean) {
    state.inited = payload;
  },
  //#region objects
  cacheObjectItem(state: DatasetStateInterface, payload: ObjectItem) {
    const index = state.cacheObjectItems.findIndex(
      (x) => x.obj_guid == payload.obj_guid,
    );
    if (index != -1) state.cacheObjectItems[index] = payload;
    else state.cacheObjectItems.push(payload);
  },
  setObjectItems(state: DatasetStateInterface, payload: ObjectItem[]) {
    state.objectItems = payload;
  },
  setObjectItem(state: DatasetStateInterface, payload: ObjectItem) {
    const index = state.objectItems.findIndex(
      (x) => x.obj_guid == payload.obj_guid,
    );
    if (index != -1) {
      state.objectItems[index] = payload;
    }
  },
  deleteObjectItems(state: DatasetStateInterface, obj_guid: string[]) {
    state.objectItems = state.objectItems.filter(
      (item) => !obj_guid.includes(item.obj_guid),
    );
  },
  setObjectsClasses(
    state: DatasetStateInterface,
    payload: { objects: string[]; classes: string[] },
  ) {
    for (const obj_guid of payload.objects) {
      const i = state.objectItems.findIndex((x) => x.obj_guid == obj_guid);
      if (i != -1) {
        if (!state.objectItems[i].classes) {
          state.objectItems[i].classes = [];
        }
        for (const class_guid of payload.classes) {
          const j =
            state.objectItems[i].classes?.findIndex((x) => x == class_guid) ??
            -1;
          if (j == -1) {
            state.objectItems[i].classes?.push(class_guid);
          }
        }
      }
    }
  },
  removeObjectsClasses(
    state: DatasetStateInterface,
    payload: { objects: string[]; classes: string[] },
  ) {
    for (const obj_guid of payload.objects) {
      const i = state.objectItems.findIndex((x) => x.obj_guid == obj_guid);
      if (i != -1) {
        for (const class_guid of payload.classes) {
          const j =
            state.objectItems[i].classes?.findIndex((x) => x == class_guid) ??
            -1;
          if (j != -1) {
            state.objectItems[i].classes?.splice(j, 1);
          }
        }
      }
    }
  },
  //#endregion

  //#region object_types
  setObjectTypes(state: DatasetStateInterface, payload: ObjectType[]) {
    state.objectTypes = payload;
  },
  //#endregion

  //#region storages
  setStorages(state: DatasetStateInterface, payload: Storage[]) {
    state.storages = payload;
  },
  //#endregion

  //#region sources
  setSources(state: DatasetStateInterface, payload: Source[]) {
    state.sources = payload;
  },
  //#endregion

  //#region markup_types
  setMarkupTypes(state: DatasetStateInterface, payload: MarkupType[]) {
    state.markupTypes = payload;
  },
  //#endregion

  //#region tags
  setTags(state: DatasetStateInterface, payload: Tag[]) {
    state.tags = payload;
  },
  setTag(state: DatasetStateInterface, payload: Tag) {
    const index = state.tags.findIndex((x) => x.tag_guid == payload.tag_guid);
    if (index != -1) {
      state.tags[index] = payload;
    } else {
      state.tags.push(payload);
    }
  },
  deleteTag(state: DatasetStateInterface, payload: string) {
    const index = state.tags.findIndex((x) => x.tag_guid == payload);
    if (index != -1) {
      state.tags.splice(index, 1);
    }
  },
  setTagParent(
    state: DatasetStateInterface,
    payload: { child_guid: string; parent_guid: string },
  ) {
    const index = state.tags.findIndex((x) => x.tag_guid == payload.child_guid);
    if (index != -1) {
      state.tags[index].parent_guid = payload.parent_guid;
    }
  },
  //#endregion

  //#region classes
  setClasses(state: DatasetStateInterface, payload: ClassItem[]) {
    state.classes = payload;
  },
  setClass(state: DatasetStateInterface, payload: ClassItem) {
    const index = state.classes.findIndex(
      (x) => x.class_guid == payload.class_guid,
    );
    if (index != -1) {
      state.classes[index] = payload;
    } else {
      state.classes.push(payload);
    }
  },
  deleteClass(state: DatasetStateInterface, payload: string) {
    const index = state.classes.findIndex((x) => x.class_guid == payload);
    if (index != -1) {
      state.classes.splice(index, 1);
    }
  },
  //#endregion

  //#region classes
  setClassGroups(state: DatasetStateInterface, payload: ClassGroupItem[]) {
    state.classGroups = payload;
  },
  setClassGroup(state: DatasetStateInterface, payload: ClassGroupItem) {
    const index = state.classGroups.findIndex(
      (x) => x.class_group_guid == payload.class_group_guid,
    );
    if (index != -1) {
      state.classGroups[index] = payload;
    } else {
      state.classGroups.push(payload);
    }
  },
  deleteClassGroup(state: DatasetStateInterface, payload: string) {
    const index = state.classGroups.findIndex(
      (x) => x.class_group_guid == payload,
    );
    if (index != -1) {
      state.classGroups.splice(index, 1);
    }
  },
  //#endregion
};

export default mutation;
